import { Text, useColorMode } from "@chakra-ui/react";

export const ThemedTextHeader = (props) => {
  const { colorMode } = useColorMode();
  const textColor = colorMode === "dark" ? "#777" : "#fff";

  return <Text {...props} color={textColor} fontSize={'16px'} />;
};
